import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {cardsData.title}
          </h2>
          <p className="text-sm text-foreground-600">一区二区及每日大赛最新精选内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.items.map((item, idx) => (
            <article
              key={idx}
              className={`bg-background-100 rounded-xl overflow-hidden group cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.hot} 阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}